<template>
  <DealSummary :deals="deals"/>
</template>

<script>
// @ is an alias to /src
import DealSummary from '@/components/DealSummary.vue';
import axios from 'axios';

export default {
  name: 'feed',
  components: {
    DealSummary,
  },
  data() {
    return {
      deals: [],
    };
  },
  mounted () {
    axios
      .get('https://apibeta.nimtu.com/v1/deals')
      .then(response => (this.deals = response.data))
  }
};
</script>
